export default __webpack_public_path__ + "static/media/company.09ec30b9.svg";